import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { PipelineDataContext } from './DDPDataProvider'

function DDPValueProvider ({ value, children }) {
  const providerValue = useMemo(() => {
    return {
      data: value,
      isLoading: false,
      isFetching: false,
      error: null
    }
  }, [value])

  return (
    <PipelineDataContext.Provider value={providerValue}>
      {children}
    </PipelineDataContext.Provider>
  )
}

DDPValueProvider.propTypes = {
  /** The data pipeline to execute */
  value: PropTypes.any,
  children: PropTypes.node
}

export default DDPValueProvider
